export class MediaSelectDialog {
  type?: string;
  mediaType?: string;
  providerId?: string;
  preferredProviderId?: string;
  providerRole?: string;
  excludeMediaIds?: Array<string>;
  selectLimit?: number;
}
